import React, { useState } from 'react';
import { ModernButton } from '../../components/ui/ModernButton';
import { Agent } from '../../types/agent';

interface StatusCellProps {
	agent: Agent;
	onResendInvitation: (agent: Agent) => Promise<void>;
}

export const StatusCell: React.FC<StatusCellProps> = ({ agent, onResendInvitation }) => {
	const [isResending, setIsResending] = useState(false);

	const handleResend = async () => {
		setIsResending(true);
		try {
			await onResendInvitation(agent);
		} finally {
			setIsResending(false);
		}
	};

	// An inactive agent is only a genuine pending invite if they never completed registration.
	// firebaseUserId is written when registration completes (and when an existing login is first
	// linked to the agent record); lastLoginAt is written on every successful login. Either one
	// proves the account exists, so isActive === false means the agent was deliberately deactivated.
	const hasCompletedRegistration = Boolean(agent.firebaseUserId || agent.lastLoginAt);

	if (!agent.isActive && !hasCompletedRegistration) {
		return (
			<ModernButton
				variant="ghost"
				size="sm"
				icon="pi pi-envelope"
				onClick={handleResend}
				loading={isResending}
				disabled={isResending}
				title="Click to resend invitation"
				className="resend-invitation-btn"
			>
				Pending - Resend
			</ModernButton>
		);
	}

	if (!agent.isActive) {
		return (
			<span className="status-badge status-deactivated">
				<i className="pi pi-ban"></i>
				Deactivated
			</span>
		);
	}

	return (
		<span className="status-badge status-active">
			<i className="pi pi-check"></i>
			Active
		</span>
	);
};

